import CartIcon from "~/assets/icons/CartIcon"
import Logo from "~/assets/icons/Logo"
import MailHeader from "~/assets/icons/MailHeader"
import PhoneHeader from "~/assets/icons/PhoneHeader"
import SearchIcon from "~/assets/icons/SearchIcon"
import UserIcon from "~/assets/icons/UserIcon"
import VisitHeader from "~/assets/icons/VisitHeader"
import { CartDrawer } from "../CartDrawer.client"
import Navigation from "../navigation/Navigation.client"
import TrustPilotManagement from '../../home/TrustPilotManagement.client'
import CartBadge from "./CartBadge.client"
import { MenuItem } from "~/types"
import { contactInfo, header, trustPilotCustomSetting, trustPilotTop } from "../../../../setup/settings/index"
import TrustPilotCustom from "../../../../setup/components/TrustPilotCustom.client"
import FacebookIcon from "~/assets/icons/FacebookIcon"
import InstagramIcon from "~/assets/icons/InstagramIcon"
import LinkedinIcon from "~/assets/icons/LinkedinIcon"
import PinterestIcon from "~/assets/icons/PinterestIcon"
import TwitterIcon from "~/assets/icons/TwitterIcon"
import YoutubeIcon from "~/assets/icons/YoutubeIcon"
import { isNonTransactional } from "../../../../setup/settings/__nonTransactional"
import { routeWishList, wishlistButtonNextTitle } from "../../../../setup/settings/__product"
import WishButtonIcon from "../../../../setup/custom_icons/WishButtonIcon"
import { Metafield } from "@shopify/hydrogen/storefront-api-types"
import TaglineComponent from "./Tagline.client"
import TikTokIcon from "~/assets/icons/TikTokIcon"


type DesktopHeaderProps = {
    isCartOpen: boolean,
    closeCart: () => void,
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    goTo: (path: string) => void,
    openCart: () => void,
    menuItems: MenuItem[]
    showCategory: string | boolean,
    shopSettings: any,
    currency: string,
    tagline?: Metafield
}

export default function DesktopHeader({ isCartOpen, closeCart, setShowCategory, goTo, openCart, showCategory, menuItems, shopSettings, currency, tagline }: DesktopHeaderProps) {
    return (
        <>
            <CartDrawer currency={currency} isOpen={isCartOpen} onClose={closeCart} />
            {header.activityBar.show &&
                <div className="NotificationPromo">
                    <div className="NotificationPromo__container">
                        <div className="NotificationPromo__text__side">
                            {header.activityBar.socialButtons &&
                                <div className="headerLeftLogo__topArea">
                                    <div className="topUserArea loginCart text-right">
                                        <a className="iconsInformation__call" href={`tel:${contactInfo.phone}`}><PhoneHeader /> <span className="text-white ml-2 mr-4">{contactInfo.phone}</span></a>
                                        {contactInfo.facebook && contactInfo.facebook != 'facebook' && <a href={contactInfo.facebook} target="_blank"><FacebookIcon transparent /></a>}
                                        {contactInfo.instagram && contactInfo.instagram != 'instagram' && <a href={contactInfo.instagram} target="_blank"><InstagramIcon transparent /></a>}
                                        {contactInfo.twitter && contactInfo.twitter != 'twitter' && <a href={contactInfo.twitter} target="_blank"><TwitterIcon transparent /></a>}
                                        {contactInfo.pinterest && contactInfo.pinterest != 'pinterest' && <a href={contactInfo.pinterest} target="_blank"><PinterestIcon transparent /></a>}
                                        {contactInfo.youtube && contactInfo.youtube != 'youtube' && <a href={contactInfo.youtube} target="_blank"><YoutubeIcon transparent /></a>}
                                        {contactInfo.linkedin && contactInfo.linkedin != 'linkedin' && <a href={contactInfo.linkedin} target="_blank"><LinkedinIcon transparent /></a>}
                                        {contactInfo.tiktok && contactInfo.tiktok != 'tiktok' && <a href={contactInfo.tiktok} target="_blank"><TikTokIcon transparent /></a>}
                                    </div>
                                </div>
                            }
                        </div>
                        <TaglineComponent tagline={tagline} />
                        <div className="NotificationPromo__text__side">
                            {header.activityBar.showActionButtons &&
                                <div className="headerLeftLogo__topArea">
                                    <div className="topUserArea loginCart text-right">
                                        <div className="topUserArea__login">
                                            <a href='/account'><UserIcon /></a>
                                        </div>
                                        <button onClick={openCart} className='relative flex items-center justify-center w-8 h-8'>
                                            <CartIcon />
                                            <CartBadge />
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
            <div onMouseLeave={() => setShowCategory(false)} className="hidden lg:block top-0 z-50">
                <div className="header flex flex-row items-center px-8" onMouseEnter={() => setShowCategory(false)}>
                    {/* TODO: move image in assets image */}
                    <div className="basis-4/12">
                        <div className="iconsInformation">
                            <a className="iconsInformation__call" href={`tel:${contactInfo?.phone}`}>
                                <i><PhoneHeader /></i>Call {contactInfo?.phone}
                            </a>
                            <a className="iconsInformation__email" href={`mailto:${contactInfo?.mailTo}`}>
                                <i><MailHeader /></i>Email us
                            </a>
                            <a className="iconsInformation__visit" href={contactInfo?.page}>
                                <i><VisitHeader /></i>Visit us
                            </a>
                        </div>
                    </div>
                    <div className="logo basis-4/12">
                        <a className="aLogo" href="/">
                            <Logo />
                        </a>
                    </div>
                    <div className="topUserArea loginCart basis-4/12 text-right">
                        <div className="topUserArea__search-container">
                            <div className="topUserArea__search">
                                <form action={`/products`} method="GET">
                                    <input name="search" type="search" placeholder="Search..." />
                                    <i className="fa">
                                        <button type='submit' className='buttonSearch'><SearchIcon /></button>
                                    </i>
                                </form>
                            </div>
                        </div>
                        {wishlistButtonNextTitle &&
                            <div className="topUserArea__login">
                                <a href={routeWishList}><WishButtonIcon /></a>
                            </div>
                        }
                        <div className="topUserArea__login">
                            <a href='/account'><UserIcon /></a>
                        </div>
                        <div className="topUserArea__cart">
                            {!isNonTransactional &&
                                <button onClick={openCart} className='relative flex items-center justify-center w-8 h-8'>
                                    <CartIcon />
                                    <CartBadge />
                                </button>
                            }
                        </div>

                    </div>
                </div>
                {trustPilotTop.visibility && trustPilotTop.position == 1 &&
                    <div className="trustPilotMenu">
                        <TrustPilotManagement type={0}></TrustPilotManagement>
                    </div>
                }
                <Navigation css={""} menuItems={menuItems} showCategory={showCategory} setShowCategory={setShowCategory} shopSettings={shopSettings} />
                {trustPilotCustomSetting.header.desktop ? <TrustPilotCustom testimonials={true} ></TrustPilotCustom> : <></>}
            </div>
        </>
    )
}